import { createContext } from 'react';

/**
 * How far a settings page has loaded. Parts that wait for their data hold the
 * page back; the page shows them once nothing holds it back any more.
 */
export interface SettingsPageReadiness {
  /** The page has shown its loaded content; a part that loads again shows in place. */
  ready: boolean;
  /** Holds the page back until the returned release is called. */
  hold: () => () => void;
}

export const SettingsPageReadinessContext =
  createContext<SettingsPageReadiness | null>(null);
